jQuery(function($) {
  // Filtering for CPTs
  // Bind our Select action to the main container
  $('.category_filter__links li a').on('click', function(e) {
    e.preventDefault();

    // Saving dem brackets
    const $this = $(this);
    const container = $('#ajax-container');

    const href = $this.attr('href')
    const term = $this.data('term');
    const page = $this.data('page');

    const tax = container.data('tax');
    const post_type = container.data('post-type')
    const per_page = container.data('per-page')

    // First we need to remove existing 'selected' attributes, then add selected to changed Option
    // This allows us to know which Taxonomy & Term we can grab for pagination
    $('.category_filter__links li').removeClass("active-term");
    $this.parent("li").addClass("active-term");

    // Build our query parameters from our selected Option
    const params = { href, tax, term, page, per_page, post_type };

    // Run query
    get_posts(params, container);
  });

  // Bind our pagination link
  bind_pagination();

  function scroll_to_posts() {
    $('html, body').animate({ 
      scrollTop: $('#ajax-container').offset().top-180 },
      150,
      "linear"
    )
  }

  // This is our main AJAX function, some micro copy for status will be edited here
  function get_posts(params, container) {
    const content = container.find(".ajax-content");
    const pagination = container.find(".ajax-pagination")
    
    $.ajax({
      url: kpa.ajax_url,
      data: {
        action: "do_filter_posts",
        nonce: kpa.nonce,
        params: params
      },
      type: "post",
      dataType: "json",
      success: function(data, textStatus, XMLHttpRequest) {
        if (data.status === 200) {
          container.data('term', data.term);
          content.html(data.content);
          pagination.html(data.pagination)
        }
      },
      complete: function(data, textStatus) {
        rebind_pagination();
        scroll_to_posts();
        history.replaceState({}, '', params.href)
      },
      error: function(MLHttpRequest, textStatus, errorThrown) {
        console.log('error');
        console.log(MLHttpRequest);
        console.log(textStatus);
        console.log(errorThrown);
      }
    });
  }

  function rebind_pagination() {
    $('.pagination li a').off('click');
    bind_pagination();
  }

  function bind_pagination() {
    $('.pagination a').on('click', function (e) {
      e.preventDefault();

      const $this = $(this);
      const container = $('#ajax-container');

      const href = $this.attr('href');
      const page = page_from_url(href)

      const term = container.data('term');
      const tax = container.data('tax');
      const post_type = container.data('post-type')
      const per_page = container.data('per-page')

      // Build our parameters
      const params = {href, term, tax, post_type, per_page, page};

      // Run query
      get_posts(params, container);
    });
  }

  function page_from_url( url ) {
    const match = url.match(/(?:\/page\/|[?&]paged=)([1-9]\d*)/)
    if ( match ) {
      return Number(match[1]);
    }
    return 1;
  }

});